/**
 * What a chosen chip looks like, in the two places AI drawers offer chips: the
 * example prompts above a text box, and the length presets on a date range.
 *
 * Painted by hand rather than with `variant="filled"`, because the app theme
 * sets `MuiChip.root.backgroundColor: 'unset'` (views/App/mui-theme.js) — every
 * filled chip in the app is therefore transparent, and a chosen chip came out
 * as white text on a white drawer. Fixing that theme rule would reach every
 * Chip in the app, all of which are now shaped around it.
 *
 * Shared so the two do not drift: they sit in the same drawers and a viewer
 * reads them as one kind of control.
 */
export const selectedChipSx = {
  backgroundColor: 'primary.main',
  borderColor: 'primary.main',
  color: '#fff',
  // Matched against MUI's OWN hover selector, not a plain `&:hover`.
  //
  // MUI ships `.MuiChip-clickable:hover { background-color: rgba(primary, .04) }`
  // for these chips. That is two classes; a plain `&:hover` is one, so MUI won
  // and hovering a chosen chip wiped its background back to a 4% tint — while
  // `color: #fff` above, which is not inside a hover block, stayed. White label,
  // all but transparent background, white drawer: the word vanished under the
  // cursor. Matching class-for-class puts this rule last and equal, so it wins.
  '&.MuiChip-clickable:hover': { backgroundColor: 'primary.dark' }
};
